import React, { useState } from "react";

import SinglePagePDFViewer from "../pdf/single-page";
import AllPagesPDFViewer from "../pdf/all-pages";

import axios from "axios";

import "../../styles.css";

const PdfUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [testPdf, setTestPdf] = useState(null);
  // On file select (from the pop up)
  const onFileChange = (event) => {
    // Update the state
    setSelectedFile({ selectedFile: event.target.files[0] });
    setTestPdf({ file: URL.createObjectURL(event.target.files[0]) });
    console.log(selectedFile);
  };
  // On file upload (click the upload button)
  const onFileUpload = () => {
    // Create an object of formData
    const formData = new FormData();
    // Update the formData object
    formData.append("myFile", selectedFile);

    // Details of the uploaded file
    console.log(selectedFile);
    console.log(testPdf);
    console.log(formData);

    // Request made to the backend api
    // Send formData object
    axios.post("api/uploadfile", formData);
  };

  // File content to be displayed after
  // file upload is complete
  const fileData = () => {
    if (selectedFile) {
      return (
        <div>
          {/* <h2>File Details:</h2>

          <p>File Name: {selectedFile?.selectedFile.name}</p>

          <p>File Type: {selectedFile?.selectedFile.type}</p>

          <p>
            Last Modified:{" "}
            {selectedFile?.selectedFile.lastModifiedDate.toDateString()}
          </p> */}

          <AllPagesPDFViewer pdf={testPdf.file} />
        </div>
      );
    } else {
      return (
        <div
          style={{
            paddingTop: 20,
          }}
        >
          <br />
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ paddingBottom: 20, width: "50%" }}>
        <input type="file" onChange={onFileChange} />
        <button
          onClick={() => onFileUpload()}
          style={{ width: 200, backgroundColor: "#ff7a59", borderRadius: 10 }}
        >
          Carregar arquivo!
        </button>
      </div>
      <div>{fileData()}</div>
    </div>
  );
};

export default PdfUpload;
